/* sh-shestia-data.js : les fonctions des données de nos ajouts (quiz, closet, sélecteur couleur et taille), module
   AJOUTS, 03/10/2026. Elles étaient écrites en ligne dans chaque page avec les données (snippets/sh-shestia-data.liquid) ;
   demande de Naotag du 03/10 (« et optimise les temps de chargements des pages, des images, de tout stp ») : le code
   passe dans ce fichier, mis en cache d'une page à l'autre, et la page ne garde que les données des robes, en JSON
   (<script type="application/json" id="sh-donnees-robes">, lu ici). Chargé en defer avant sh-branchement.js,
   sh-shestia-ui.js, sh-quiz-engine.js, sh-quiz.js et sh-closet.js : l'objet window.Shestia est le même qu'avant et prêt
   avant eux. Ce qui suit est la logique reprise du snippet telle quelle (règles d'origine :
   sites/shestia-sky-2026-09-26/shestia-actuel/shestia-data.js). */
(function () {
  'use strict';
  var S = window.Shestia = window.Shestia || {};
  var noeud = document.getElementById('sh-donnees-robes');
  var DONNEES = {};
  try { DONNEES = JSON.parse(noeud ? noeud.textContent : '{}') || {}; } catch (e) { DONNEES = {}; }
  /* Variantes écrites en tableaux [id, couleur, taille, dispo] pour alléger la page : remises ici en objets. */
  var BRUT = (DONNEES.robes || []).map(function (b) {
    b.variantes = (b.variantes || []).map(function (v) { return {id: v[0], couleur: v[1], taille: v[2], dispo: !!v[3]}; });
    return b;
  });

  /* Pastilles par nom de couleur, quand la robe n'a pas la sienne (ligne du closet, carte « pas encore de photo »). */
  var SWATCHES = {
    'Red':'#9d1f2a','Pink':'#e5a8b7','Sky Blue':'#9fc8df','Sky blue':'#9fc8df','Black and white':'linear-gradient(135deg,#111 50%,#f5f3ee 50%)',
    'Dark brown':'#3f2a24','Brown':'#694a3d','Green':'#dae1d3','Yellow':'#e7d05c','Dark Blue':'#172a4d','Dark blue':'#172a4d','Wine red':'#6f1f32','Black':'#171717',
    'Deep purple':'#43294f','Light yellow':'#f0e5a9','Army Green':'#596044','Champagne color':'#d7c0a0','Navy blue':'#17233f',
    'Light Blue':'#b8d8e8','White':'#f4f1eb'
  };
  /* 30/09 au soir, Naotag : « pour les variantes de coueurs met en avant d'abord les couleurs les plus connus que les gens
     achètent donc a gauche les plus communes a cahter et plus vers la dorite de moins en moins commune ». */
  var POPULAIRES = ['Black', 'White', 'Dark blue', 'Dark Blue', 'Navy blue', 'Red', 'Wine red', 'Black and white', 'Champagne color',
    'Pink', 'Sky blue', 'Sky Blue', 'Light Blue', 'Dark brown', 'Brown', 'Green', 'Army Green', 'Yellow', 'Light yellow', 'Deep purple'];
  function rang(nom) { var i = POPULAIRES.indexOf(nom); return i < 0 ? POPULAIRES.length : i; }
  /* Couleur d'un média : son texte alternatif, « Red Halter Maxi in Pink, view 1 of 4 ». */
  function couleurDe(alt) { var m = /\bin (.+?), view \d+ of \d+\s*$/i.exec(alt || ''); return m ? m[1] : null; }
  /* 03/10 : un nom de couleur se cherche sans tenir compte de la casse (« Sky blue » / « Sky Blue ») tant que les
     options, les métachamps et le texte alternatif des médias ne l'écrivent pas tous pareil. */
  function sansCasse(obj, nom) {
    if (!obj || nom == null) return undefined;
    if (obj[nom] !== undefined) return obj[nom];
    var bas = String(nom).toLowerCase();
    for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && k.toLowerCase() === bas) return obj[k];
    return undefined;
  }
  function memeCouleur(liste, nom) {
    var bas = String(nom || '').toLowerCase();
    for (var i = 0; i < (liste || []).length; i++) if (String(liste[i]).toLowerCase() === bas) return liste[i];
    return nom;
  }

  var variantMedia = {};
  var products = BRUT.map(function (b) {
    var parCouleur = {}, toutes = [], studio = {};
    /* les photos studio de la référence (métachamp de boutique custom.ajouts), sinon les médias du produit (la page ne
       les écrit que si aucune photo studio n'a été trouvée pour la robe) */
    Object.keys(b.studio || {}).forEach(function (c) {
      var l = (b.studio[c] || []).filter(Boolean);
      if (l.length) studio[c] = l;
    });
    if (Object.keys(studio).length) {
      Object.keys(studio).forEach(function (c) { parCouleur[c] = studio[c]; toutes = toutes.concat(studio[c]); });
    } else {
      (b.photos || []).forEach(function (x) {
        var c = couleurDe(x[0]) || b.colour;
        (parCouleur[c] = parCouleur[c] || []).push(x[1]);
        toutes.push(x[1]);
      });
    }
    variantMedia[b.id] = parCouleur;
    var product = {id: b.id, name: b.name, colour: memeCouleur(b.colours, b.colour), length: b.length, sizes: b.sizes || [], colours: b.colours || [],
      moods: b.moods || [], occasions: b.occasions || [], reason: b.reason || ''};
    product.images = toutes;
    product.gallery = sansCasse(parCouleur, product.colour) || toutes.slice(0, 1);
    product.image = product.gallery[0] || '';
    product.signature = false;
    product.signatureImage = product.image;
    /* centimes (Shopify) ; null tant que le prix n'est pas posé */
    product.priceAud = typeof b.prix === 'number' && b.prix > 0 ? b.prix : null;
    product.priceStatus = product.priceAud === null ? 'Retail price pending physical sample review' : '';
    product.variants = product.colours.slice().sort(function (x, y) { return rang(x) - rang(y); }).map(function (name) {
      return {name: name, swatch: sansCasse(b.pastilles, name) || sansCasse(SWATCHES, name) || '#b4afa7'};
    });
    product.url = b.url;
    product.shopify = b.variantes || [];
    return product;
  });
  function byId(id) { return products.find(function (p) { return p.id === id; }); }
  /* La variante de la boutique pour une couleur et une taille ; sans taille, la première taille de la couleur. Aucune
     variante approchée : une couleur ou une taille absente rend null (build/fusion/branchement.js). */
  function variante(id, colour, size) {
    var p = byId(id);
    if (!p) return null;
    colour = colour || p.colour;
    return p.shopify.find(function (v) { return v.couleur === colour && (size ? v.taille === size : true); }) || null;
  }
  function href(product, colour, size) {
    var p = product && byId(product.id);
    if (!p) return '/collections/all';
    if ((!colour || colour === p.colour) && !size) return p.url;
    var v = variante(p.id, colour, size);
    return v ? p.url + '?variant=' + v.id : p.url;
  }
  function hasColour(p, colour) { return !!p && p.variants.some(function (v) { return v.name === colour; }); }
  function hasSize(p, size) { return !!p && p.sizes.indexOf(size) > -1; }
  function swatch(name) { return sansCasse(SWATCHES, name) || '#b4afa7'; }
  /* Photos d'une couleur : la galerie pour la couleur photographiée, sinon les seules photos de CE coloris.
     Jamais la photo d'un autre coloris à sa place (Naotag, 24/09 : « identifie précisément le manque »). */
  function imagesFor(p, colour) { return !p ? [] : colour === p.colour ? p.gallery : (sansCasse(variantMedia[p.id], colour) || []); }
  function hasPhoto(p, colour) { return imagesFor(p, colour).length > 0; }
  function esc(v) { return String(v).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  /* Une couleur sans photo s'affiche en carte neutre qui porte sa pastille et le dit en clair. */
  function missingCard(p, colour) {
    var fill = swatch(colour), pair = fill.match(/#[0-9a-f]{3,6}/gi) || [fill], disc;
    disc = pair.length > 1
      ? '<circle cx="400" cy="430" r="120" fill="' + esc(pair[1]) + '"/><path d="M315 345 A120 120 0 0 0 485 515 Z" fill="' + esc(pair[0]) + '"/>' +
        '<circle cx="400" cy="430" r="120" fill="none" stroke="rgba(0,0,0,.14)" stroke-width="2"/>'
      : '<circle cx="400" cy="430" r="120" fill="' + esc(pair[0]) + '" stroke="rgba(0,0,0,.12)" stroke-width="2"/>';
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="800" height="1000" viewBox="0 0 800 1000">' +
      '<rect width="800" height="1000" fill="#efece7"/>' + disc +
      '<text x="400" y="620" text-anchor="middle" font-family="Arial, sans-serif" font-size="34" fill="#2b2926">' + esc(p.name) + ' in ' + esc(colour) + '</text>' +
      '<text x="400" y="668" text-anchor="middle" font-family="Arial, sans-serif" font-size="28" fill="#6b6862">No photo of this colour yet</text></svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }
  function imageFor(p, colour) { var list = imagesFor(p, colour); return list[0] || (p ? missingCard(p, colour) : ''); }
  function missingPhotos() {
    var out = [];
    products.forEach(function (p) { p.variants.forEach(function (v) { if (!hasPhoto(p, v.name)) out.push({id:p.id, name:p.name, colour:v.name}); }); });
    return out;
  }
  /* Paliers convenus par Naotag le 15/09 : « quand elles prennent une deuxième robe elles ont 10% de réduction sur la
     deuxième robe, 3 robes 15% de réduction sur la commande, 4 robes 20% ». Livraison offerte dès la première robe. */
  var offer = {
    tiers: [
      {count:2, rate:.10, scope:'second', short:'10% off', label:'10% off the second dress'},
      {count:3, rate:.15, scope:'order', short:'15% off', label:'15% off the whole order'},
      {count:4, rate:.20, scope:'order', short:'20% off', label:'20% off the whole order', orMore:true}
    ],
    gifts: [],
    freeShipping: {from: 1}
  };
  function tierFor(count) { var t = null; offer.tiers.forEach(function (x) { if (count >= x.count) t = x; }); return t; }
  function nextTier(count) { return offer.tiers.find(function (x) { return x.count > count; }) || null; }
  function price(p) { return p && typeof p.priceAud === 'number' ? p.priceAud : null; }
  /* Un seul calcul pour le closet et le panier. lines = [{id, colour, size, qty}]. Montants en centimes. */
  function pricing(lines) {
    var units = [];
    (lines || []).forEach(function (l) { var p = byId(l.id); if (!p) return; for (var i = 0; i < (l.qty || 1); i++) units.push(p); });
    var count = units.length, tier = tierFor(count), next = nextTier(count);
    var priced = count > 0 && units.every(function (p) { return price(p) !== null; });
    var subtotal = priced ? units.reduce(function (s, p) { return s + price(p); }, 0) : null, saving = null;
    if (priced) {
      if (!tier) saving = 0;
      else if (tier.scope === 'second') { var sorted = units.map(price).sort(function (a, b) { return a - b; }); saving = Math.round(sorted[0] * tier.rate); }
      else saving = Math.round(subtotal * tier.rate);
    }
    return {count:count, tier:tier, next:next, toNext:next ? next.count - count : 0, priced:priced, subtotal:subtotal, saving:saving, total:priced ? subtotal - saving : null};
  }
  var api = {imagesFor:imagesFor, imageFor:imageFor, hasPhoto:hasPhoto, missingPhotos:missingPhotos, hasColour:hasColour, hasSize:hasSize,
    swatch:swatch, products:products, byId:byId, href:href, variante:variante, currency:DONNEES.devise || 'AUD',
    offer:offer, tierFor:tierFor, nextTier:nextTier, pricing:pricing, esc:esc};
  Object.keys(api).forEach(function (k) { S[k] = api[k]; });
  /* Le cœur (sh-core.js) pose Shestia.money au format de la boutique ; s'il manque, le même format. */
  if (typeof S.money !== 'function') {
    S.money = function (cents) { var n = (parseInt(cents, 10) || 0) / 100; return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' AUD'; };
  }
})();
